import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ImageGroup from 'components/ImageGroup'
// import CloudinarySolarnetImage from 'components/CloudinarySolarnetImage'
import s from './Portfolio.module.css'
import createGalleryRows from '../../../helpers/createGalleryRows'
import isSingleRowItem from '../../../helpers/isSingleRowItem'
import Video from '../Video'

// TODO: Add alt to images.
function Portfolio({
  images = [],
  isPortraitImg = false,
  fallbackImg = false,
}) {
  if (images?.length < 1) {
    return null
  }
  const useImages =
    isPortraitImg === true || fallbackImg === true ? images.slice(1) : images

  if (useImages.length === 0) {
    return null
  }

  const rows = createGalleryRows(useImages)

  return rows.map((row, index) => (
    <ImageGroup key={`${row.sourceUrl}${index}`} className={s.row}>
      {(handleLoad, indexToResize, ratio) =>
        row.map((image, index) => (
          <div
            key={`${image.sourceUrl}${index}`}
            className={classNames(s.imageWrapper, {
              [s.imageWrapperLandscape]: isSingleRowItem(image),
            })}
          >
            {'videoType' in image && <Video video={image} />}
            {!('videoType' in image) && index === indexToResize && (
              <span
                className={s.imageRatio}
                style={{ paddingTop: `${ratio * 100}%` }}
              />
            )}
            {!('videoType' in image) && (
              <img
                src={image.sourceUrl}
                className={classNames(s.image, {
                  [s.imageResized]: index === indexToResize,
                })}
                alt=""
              />
              // <CloudinarySolarnetImage
              //   className={classNames(s.image, {
              //     [s.imageResized]: index === indexToResize,
              //   })}
              //   image={[
              //     { url: image.sourceUrl, params: 'w_657,c_fill,f_auto' },
              //     row.length === 1
              //       ? { url: image.sourceUrl, params: 'w_1314,c_fill,f_auto' }
              //       : null,
              //   ]}
              //   // onLoad={(w, h) => handleLoad(index, w, h)}
              // />
            )}
          </div>
        ))
      }
    </ImageGroup>
  ))
}

Portfolio.propTypes = {
  images: PropTypes.array,
  isPortraitImg: PropTypes.bool,
  fallbackImg: PropTypes.bool,
}

export default Portfolio
